import { Component, DestroyRef, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreModule } from './core/core.module';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { IdleService } from './shared/services/idle.service';
import { VersionCheckService } from './shared/services/version-check.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VersionCheckServiceTsService } from '../assets/version-services/version-check.service.ts.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CoreModule, ToastModule, RippleModule],
  providers: [MessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'JBN-Frontend';
  constructor(
    private messageService: MessageService,
    // private versionCheckService: VersionCheckService,
    private idleService: IdleService,
    private versionService: VersionCheckServiceTsService,
    private destroyRef: DestroyRef
  ) {
    effect(() => {
      const message = this.idleService.toastMessageSignal();
      if (message) {
        // Show toast, or trigger UI logic
        this.messageService.add(message);
      }
    });
   this.versionService
  .startVersionCheck()
  .pipe(takeUntilDestroyed(this.destroyRef))
  .subscribe();

  }
}
